// V5.1 shared naming — mirrors backend services/catalog_naming.color_naming. Never invents a U.S. name.
export const US_NAME_PENDING = "U.S. name pending";

export function colorNames(row = {}) {
  const moroccan = (row.color_name || "").trim();
  const us = (row.us_color_name || row.display_color_name || "").trim();
  const approved = !!us && us.toUpperCase() !== moroccan.toUpperCase();
  return { moroccan, us: approved ? us : null, pending: !approved, code: row.color_code || null };
}

// Dealer-facing: U.S. name first, Moroccan second.
export function dealerColorLabel(row) {
  const { moroccan, us } = colorNames(row);
  return us ? `${us} / ${moroccan}` : moroccan;
}

// Admin-facing: "001 — HRECH · UNGLAZED" (or "· U.S. name pending").
export function adminColorLabel(row) {
  const { moroccan, us, code } = colorNames(row);
  return `${code ? `${code} — ` : ""}${moroccan} · ${us || US_NAME_PENDING}`;
}

// Dealer title for a line/row: prefer backend dealer_label; otherwise reorder the canonical variant_label.
export function dealerLabel(row = {}) {
  if (row.dealer_label) return row.dealer_label;
  const label = row.variant_label || row.label || "";
  const { moroccan, us } = colorNames(row);
  if (us && moroccan && label.includes(`${moroccan} / ${us}`)) return label.replace(`${moroccan} / ${us}`, `${us} / ${moroccan}`);
  return label;
}

// ID-068: "Code · Moroccan Name · US Color Name" from the approved color catalog; missing names are omitted, never invented
export function colorOptionLabel(row = {}) {
  return [row.color_code, row.moroccan_name, row.us_color_name].filter((v) => v && String(v).trim()).join(" · ");
}

